import { isNullOrUndefined } from '@/utils/comparators'
import { fetchUserActivity as fetchUserActivityFromApi } from '@/api/user'

const fetchUserActivity = async ({ commit }, latestSequenceNumber) => {
  try {
    let response = await fetchUserActivityFromApi(latestSequenceNumber)
    commit('SET_USER_ACTIVITY', response)
  } catch (ex) {
    console.log(ex)
  }
}

const loadUserActivity = async ({ dispatch, state }, latestSequenceNumber) => {
  if (isNullOrUndefined(state.userActivityItems) || !isNullOrUndefined(latestSequenceNumber)) {
    await dispatch('fetchUserActivity', latestSequenceNumber)
  }
}

export default {
  fetchUserActivity,
  loadUserActivity
}



// WEBPACK FOOTER //
// ./src/store/modules/user/activity/actions.js